import { render, staticRenderFns } from "./RviewOrder.vue?vue&type=template&id=6baf9116&scoped=true"
import script from "./RviewOrder.vue?vue&type=script&lang=js"
export * from "./RviewOrder.vue?vue&type=script&lang=js"
import style0 from "./RviewOrder.vue?vue&type=style&index=0&id=6baf9116&prod&scoped=true&lang=scss"
import style1 from "./RviewOrder.vue?vue&type=style&index=1&id=6baf9116&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6baf9116",
  null
  
)

export default component.exports